import script from "./bpDirection.vue?vue&type=script&setup=true&lang=js"
export * from "./bpDirection.vue?vue&type=script&setup=true&lang=js"

import "./bpDirection.vue?vue&type=style&index=0&id=5c4fd016&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c4fd016"]])

export default __exports__